// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"3bdef1dc","453":"e66fa15b","796":"86d22fba"}[chunkId] + ".chunk.js";
};